import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { SimpleTable } from '~/components';
import { Input } from '~/components/Form';
import { t } from '~/helpers';

import { FormWrapper } from './styles';
import * as S from './styles';

export default function MyForm({ data, reference, close }) {
  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <S.Wrapper>
      <FormWrapper ref={reference} initialData={data}>
        {/* <Input
            name="msg01mensagemsistema"
            label={t('s.menu.cadastro.mensagem.msg01mensagemsistema')}
          /> */}

        <SimpleTable
          style={{ width: '100%' }}
          url="historicomensagemsistema"
          cells={[
            {
              id: 'idhistoricomensagemsistema',
              label: 'ID',
            },
            {
              id: 'nomeabreviadoposto',
              label: 'Posto',
            },
            {
              id: 'nomeusuario',
              label: 'Usuário',
            },
            {
              id: 'idterminal',
              label: 'Terminal',
            },
            {
              id: 'idbico',
              label: 'Bico',
            },
            {
              id: 'dataHoraLoghistoricomensagemsistema_str',
              label: 'Data',
            },
          ]}
          unique={['idhistoricomensagemsistema']}
          form={MyForm}
          onCreate={false}
          onUpdate={false}
          onDelete={false}
          title="Histórico"
          restProps=""
          query={{
            wherefield: ['idmensagemsistema'],
            valuewherefield: [data.idmensagemsistema],
            typewherefield: ['EQUALS'],
          }}
        />
      </FormWrapper>
    </S.Wrapper>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
